module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10195.1bde82d5.jpg";